import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectfetchQualityAlertLoading, selectFilteredQualityAlerts, selectQualityAlertLoading } from './store/selectors';
import { editQualityAlertData } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const QualityAlertTable = () => {
  const dispatch = useDispatch();

  const { filteredData, isLoading, isFetchDataLoading } = useSelector(state => ({
    filteredData: selectFilteredQualityAlerts(state),
    isLoading: selectQualityAlertLoading(state),
    isFetchDataLoading: selectfetchQualityAlertLoading(state),
  }));

  const handleEditClick = record => {
        dispatch(editQualityAlertData(record.workorderid));
  };

  const columns = [
    {
      title: 'Part ID',
      dataIndex: 'partid',
      sorter: (a, b) => a.partid.length - b.partid.length,
    },
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'Description',
      dataIndex: 'description',
       sorter: (a, b) => a.wtname.length - b.wtname.length,
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>       
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default QualityAlertTable;
